module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-landing"
  }, [(_vm.loading === false) ? _c('div', {
    staticClass: "container slick-wrapper",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.title,
      attrs: {
        "caption": item.title,
        "href": item.image.path,
        "src": item.image.path
      }
    }, [(_vm.isDesktop) ? _c('img', {
      attrs: {
        "src": item.image.path
      }
    }) : _c('img', {
      attrs: {
        "src": item.image_mobile.path
      }
    })])
  }))], 1) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "arrow-down"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$scrollTo('#gallery-container')
      }
    }
  }, [_c('span')])]), _vm._v(" "), _c('masonry-instagram', {
    attrs: {
      "id": "section-collections"
    },
    on: {
      "onItemsEnded": function($event) {
        _vm.itemsEnded = true;
      }
    }
  }), _vm._v(" "), (_vm.itemsEnded) ? _c('contact-section', {
    attrs: {
      "data-aos": "slide-up",
      "data-aos-once": "true",
      "data-aos-duration": "1000"
    }
  }) : _vm._e(), _vm._v(" "), _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3542be04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Landing.vue
// module id = 736
// module chunks = 1